import { useTranslation } from 'react-i18next'

interface YourTicketsProps {
  tickets: number[]
  roundState: number | string
}

export function YourTickets({ tickets, roundState }: YourTicketsProps) {
  const { t } = useTranslation()

  if (tickets.length === 0) return null

  return (
    <div className="card">
      <h3 className="text-sm font-medium text-telegram-hint mb-3">{t('tickets.yourTickets')}</h3>
      <div className="flex flex-wrap gap-2">
        {tickets.map((ticketNum) => (
          <div key={ticketNum} className={`px-3 py-2 rounded-lg font-mono text-sm font-medium ${roundState === 1 ? 'bg-yellow-500/20 text-yellow-400 animate-pulse' : roundState === 2 ? 'bg-gold-500/20 text-gold-500' : 'bg-telegram-bg text-telegram-text'}`}>
            #{ticketNum}
          </div>
        ))}
      </div>
      {roundState === 1 && <div className="mt-3 text-center text-sm text-yellow-400">🎲 {t('round.drawing')}</div>}
    </div>
  )
}
